import { Loader } from '@unmind/design-system';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';

import { useUserLocation } from 'Account/hooks';
import RoutePath from 'App/RoutePath';
import { Container, useMatches } from 'Book/shared';
import { Questionnaire, Matches } from './components';

const FindYourMatch = () => {
  const [showForm, setShowForm] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  const {
    hasValidLocationData,
    loading: locationLoading,
    error: locationError,
  } = useUserLocation();

  const {
    userHasPractitionerMatches,
    practitionerMatches,
    practitionerMatchesLoading: loading,
    practitionerMatchesError: error,
    refetchPractitionerMatches,
  } = useMatches({
    skip: locationLoading || (!locationError && !hasValidLocationData),
  });

  useEffect(() => {
    if (userHasPractitionerMatches) {
      setShowForm(false);
    }
  }, [userHasPractitionerMatches]);

  if (locationLoading || loading || showLoader) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  if (error) {
    return <Redirect to={RoutePath.BookPractitioners} />;
  }

  return showForm ? (
    <Questionnaire
      onSubmit={async () => {
        setShowLoader(true);
        try {
          await refetchPractitionerMatches();
          setShowForm(false);
        } finally {
          setShowLoader(false);
        }
      }}
    />
  ) : (
    <Container>
      <Matches matches={practitionerMatches} trackingSource="home_match" />
    </Container>
  );
};

export default FindYourMatch;
